import { mutator } from 'satcheljs';
import { storeMRUSuggestionsAction } from '../actions/internalActions';
import getMRUAttachmentStore from '../store/mruAttachmentStore';

export default mutator(storeMRUSuggestionsAction, actionMessage => {
    // Update the stored items.
    const mruAttachmentStore = getMRUAttachmentStore();
    mruAttachmentStore.attachments = actionMessage.mruAttachments;
    mruAttachmentStore.traceId = actionMessage.traceId;
});
